import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { AbstractDialogData } from '@next/core-lib/dialog';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-week-registration-dialog-shell',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatIconButton,
    MatIcon,
    TranslatePipe,
  ],
  templateUrl: './week-registration-dialog-shell.component.html',
  styleUrls: ['./week-registration-dialog-shell.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WeekRegistrationDialogShellComponent {
  readonly data = input.required<AbstractDialogData>();
  readonly alt = output<void>();
  readonly dialogClose = output<void>();
  readonly confirm = output<void>();
}
